<template>
    <div style="position: absolute;">

        <!-- QUESTION DESCRIPTION POPUP -->
        <v-layout v-if="questionData !== null && typeof questionData !== 'undefined'" row justify-center >
            <v-dialog
                max-width="550"
                v-model="mustShowQuestionDescriptionPopup"
                scrollable
                content-class="question-description-dialog"
                id="close-popup"
            >

                <v-card class="component-bg-color-important" color="question-description-dialog-content">
                    <v-card-title v-if="questionData.name">

                        <v-layout column>
                            <v-flex xs12>
                                <h4>
                                    <span>{{questionData.name}}</span>
                                    <span @click="hideQuestionDescriptionPopup()" class="close-icon float-right">
                                        <close-icon :svg-fill-class="'svg-secondary-color'"/>
                                    </span>
                                </h4>
                                <div v-html="questionData.text"></div>
                            </v-flex>
                        </v-layout>

                    </v-card-title>
                    <v-card-text class="px-0">
                        <div v-if="questionData.description"
                             v-html="questionData.description"
                             class="question-description">
                        </div>
                    </v-card-text>
                </v-card>

            </v-dialog>
        </v-layout>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import CloseIcon from "../svg/shared/closeIcon";
    export default {
        name: 'QuestionDescriptionPopup',
        components: {CloseIcon},
        props: {
            questionData: {
                type: Object,
                required: false,
                default: null
            }
        },
        computed: {
            // Used for the v-dialog v-model
            // The v-dialog needs an boolean for the v-model
            mustShowQuestionDescriptionPopup: {
                get() {
                    return (this.questionData !== null) ? true : false;
                },

                set(newValue) {
                    if (newValue === false) {
                        this.hideQuestionDescriptionPopup();
                    }
                }
            }
        },
        created: function() {
            document.addEventListener('keyup', this.escapeKeyListenerUrg);
        },

        destroyed: function() {
            document.removeEventListener('keyup', this.escapeKeyListenerUrg);
        },

        methods: {
            hideQuestionDescriptionPopup() {
                this.$emit('onCloseQuestionDescPopup');
            },

            escapeKeyListenerUrg: function(evt) {
                if (evt.keyCode === 27) {
                    this.hideQuestionDescriptionPopup();
                }
            }
        }

    }
</script>



// WEBPACK FOOTER //
// src/common/components/shared/QuestionDescriptionPopup.vue